import { render, staticRenderFns } from "./rows-edit-tab.vue?vue&type=template&id=4d11daf3&scoped=true"
import script from "./rows-edit-tab.vue?vue&type=script&lang=js"
export * from "./rows-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./rows-edit-tab.vue?vue&type=style&index=0&id=4d11daf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d11daf3",
  null
  
)

export default component.exports